


let refreshPromise: Promise<string | null> | null = null;

export const refreshAccessToken = (): Promise<string | null> => {
  
  if (!refreshPromise) {
    const storedToken = localStorage.getItem('refresh-token');

    refreshPromise = fetch(`${import.meta.env.VITE_API_URL}auth/refresh-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refreshToken: storedToken }),
    })
      .then(async (response) => {
        // debugger
        const data = await response.json();
        console.log(data, "data-data");

        if (!response.ok || !data?.data?.token) return null;

        localStorage.setItem('token', data?.data?.token);
        localStorage.setItem('refresh-token', data?.data?.newRefreshToken);

        return data.data.token || null;
      })
      .catch(() => null)
      .finally(() => {
        refreshPromise = null;
        window.location.reload(); 
      });
  }

  return refreshPromise;
};



export const logoutAndRedirect = () => {
  localStorage.removeItem('auth_user')
  localStorage.removeItem('token');
  window.location.href = '/signin'; 
};
export const  toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = (error) => reject(error)
  })
